import DashboardService from '@/client/services/api/DashboardService';
import { useAuthStore } from '@/client/services/state/authStore';
import { useQuery } from '@tanstack/react-query';

export const useGetDashboardUserAssignments = () => {
  const { authConfig } = useAuthStore();
  const { user } = authConfig;

  return useQuery({
    queryKey: ['user-assignments', user._id],
    queryFn: () => DashboardService.getUserAssignments(user._id),
    select: (data) => {
      const unarchivedAssignments = data.filter((assignment) =>
        assignment.assigned_content.some(
          (content) => content.content_id && content.content_id.archived === false,
        ),
      );

      const completedAssignments = unarchivedAssignments.filter(
        (assignment) => assignment.completed,
      );

      const openAssignments = unarchivedAssignments.filter((assignment) => !assignment.completed);

      return {
        allAssignments: unarchivedAssignments,
        completedAssignments,
        openAssignments,
      };
    },
  });
};
